import PublicHeader from "../public/PublicHeader.vue";
import IntercomMixin from "../ui/IntercomMixin";
import mixins from "vue-typed-mixins";
export default mixins(IntercomMixin).extend({
    components: {
        PublicHeader: PublicHeader,
    },
});
